module.exports = __webpack_public_path__ + "img/jd.1b9f6eda.png";